import React, { useEffect, useState } from "react";
import { Button, Col, Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getClientById } from "store/clients";
import { useParams } from "react-router";
import { Descriptions, Image, Select, Table, Tabs, Upload } from "antd";
import { getLoansWithParams } from "store/loans";
import { WithdrawalForm } from "components/WithdrawalForm";
import { getAllWithdrawals } from "store/loans";
import { fallbackImg } from "utils";
import { useHandleImageUpload } from "hooks/useHandleImageUpload";
import ImgCrop from "antd-img-crop";
import { updateClient } from "store/clients";
import { getOrgStaffProfileOrgField } from "utils";
import { getOrgDashboardIdField } from "utils";
import { getAllunions, refreshSavingsAction } from "store/clients";
import { ModifiedAntTable } from "components/ModifiedAntTable";

import RefreshImg from "assets/img/arrows-rotate-solid.svg";
import EditImg from "assets/img/edit.png"
import { InputModal } from "./InputModal";

const { TabPane } = Tabs;

const withdrawalReasons = {
  payDaily: "Pay loan repayment",
  // payAllDaily: "Pay all daily repayment",
  cashWithdrawal: "Cash withdrawal",
};

const ClientProfile = () => {
  const [clientData, setClientData] = useState();
  const [clientLoans, setClientLoans] = useState();
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(true);
  const [withdrawalData, setWithdrawalData] = useState([]);
  const [triggerRefresh, setTriggerRefresh] = useState(false);

  const [unionOptions, setUnionOptions] = useState([]);
  const [unionInput, setUnionInput] = useState();
  const [assigningUnion, setAssigningUnion] = useState(false);
  const [withdrawPage, setWithdrawPage] = useState(1);
  const [loanPage, setLoanPage] = useState(1);

  const dispatch = useDispatch();
  const { id } = useParams();
  const {
    users: { user },
  } = useSelector((state) => ({
    users: state.users,
  }));
  const { handleImageChange } = useHandleImageUpload();
  const isProd = window.location.hostname === "opulentpeerless.com";

  const handleTriggerRefresh = () => setTriggerRefresh((current) => !current);

  const handleImage = async (file) => {
    const url = await handleImageChange(file, true, clientData.image);
    dispatch(updateClient(id, { image: url })).then(() => {
      handleTriggerRefresh();
    });
  };

  const handleAssignUnion = () => {
    if (!unionInput) {
      return;
    }

    setAssigningUnion(true);
    dispatch(updateClient(id, { union_id: Number(unionInput) })).then(() => {
      setAssigningUnion(false);
      handleTriggerRefresh();
    });
  };

  const handleRefreshSavings = async () => {
    if (
      window.confirm(
        "Are you sure you want to empty the savings balance?. Note: This can not be reversed"
      )
    ) {
      setLoading(true);
      dispatch(refreshSavingsAction(id)).then(() => {
        setLoading(false);
        handleTriggerRefresh();
      });
    }
  };

  const handleChangeSavingsBalance = async (value) => {
    setLoading(true);
    dispatch(refreshSavingsAction(id, value)).then(() => {
      setLoading(false);
      setTriggerRefresh((current) => !current);
    });
    setLoading(false);
  };

  useEffect(() => {
    if (!clientData?.union) {
      const orgType = getOrgStaffProfileOrgField(user?.position);
      const orgIdField = getOrgDashboardIdField(user?.position);
      const orgFieldId =
        user?.position === "CO" ? user?.id : user?.[orgType]?.id;

      let queryString = "";
      queryString = queryString.concat(`${orgIdField}=${orgFieldId}`);

      dispatch(getAllunions(queryString)).then((result) => {
        setUnionOptions(result);
      });
    }
  }, [clientData]);

  useEffect(() => {
    if (window.innerWidth > 700) {
      setIsMobile(false);
    }
  }, []);

  useEffect(async () => {
    setLoading(true);
    const res = await dispatch(getClientById(id));
    setClientData(res);

    dispatch(getLoansWithParams(`client_id=${id}`)).then((result) => {
      setClientLoans(result);
      setLoading(false);
    });

    dispatch(getAllWithdrawals(`client_id=${id}`)).then((result) => {
      setWithdrawalData(result);
    });
  }, [triggerRefresh]);

  const withdrawalColumn = [
    {
      title: "S/N",
      dataIndex: "id",
      render: (text, record, index) =>
        ((Number(withdrawPage) || 1) - 1) * 50 + (index + 1),
    },
    {
      title: "By",
      render: (text, record) => <div>{record?.author?.name}</div>,
    },
    {
      title: "Client",
      render: (text, record, index) => <div>{record?.client?.fullname}</div>,
    },
    {
      title: "Account",
      dataIndex: "account",
      render: (text, record, index) => <div>{record?.account}</div>,
    },
    {
      title: "Withdrawal Amount",
      render: (text, record, index) => (
        <div>{Number(record?.amount).toLocaleString() || "-"}</div>
      ),
    },
    {
      title: "Purpose",
      render: (text, record, index) => (
        <div>{withdrawalReasons[record?.reason] || ""}</div>
      ),
    },
  ];

  const loanColumns = [
    {
      title: "S/N",
      dataIndex: "id",
      render: (text, record, index) =>
        ((Number(loanPage) || 1) - 1) * 50 + (index + 1),
    },
    {
      title: "Client",
      dataIndex: "name",
      render: (text, record) => (
        <Link to={`/loans/${record.id}`}>
          <i className="fa fa-link" aria-hidden="true"></i>{" "}
          {`${record?.client?.fullname}`}
        </Link>
      ),
    },
    {
      title: "Request date",
      dataIndex: "creation_date",
    },
    {
      title: "Amount ₦",
      dataIndex: "loan_amount",
      render: (text, record) => <>{Number(text).toLocaleString()}</>,
    },
    {
      title: "Loan Daily Pay ₦",
      dataIndex: "daily_pay",
      render: (text, record) => <>{Number(text).toLocaleString()}</>,
    },
    {
      title: "Daily Payment Status",
      render: (text, record) => (
        <div
          className={classNames(
            "status-badge badge badge-sm",
            record?.today_payment_stat === "PAID"
              ? "badge-success"
              : "badge-warning"
          )}
        >
          {record?.today_payment_stat}
        </div>
      ),
    },
    {
      title: "Loan Status",
      render: (text, record) => (
        <div
          className={classNames(
            "status-badge badge badge-sm",
            getStatusClassName(record?.loan_status)
          )}
        >
          {record?.loan_status}
        </div>
      ),
    },
  ];

  return (
    <Container fluid>
      <h6 className="mb-3">
        {clientData?.title} {clientData?.surname} {clientData?.firstname}
      </h6>
      <h6 className="mb-3 d-flex align-items-center">
        Savings Balance: ₦{Number(clientData?.savings_balance).toLocaleString()}
        {["DR", "SM", "ZM"].includes(user?.position) && (
          <div>
            <img
              src={RefreshImg}
              alt=""
              height={15}
              width={15}
              className="ml-2"
              role="button"
              onClick={handleRefreshSavings}
            />

            <InputModal
              value={clientData?.savings_balance}
              onSubmit={handleChangeSavingsBalance}
            >
              <img
                src={EditImg}
                alt="edit"
                height={15}
                width={15}
                className="ml-2"
                role="buton"
              />
            </InputModal>
          </div>
        )}
      </h6>
      <h6 className="mb-3">
        Union Balance: ₦{Number(clientData?.union_balance).toLocaleString()}
      </h6>
      <Tabs
        tabPosition={isMobile ? "top" : "left"}
        defaultActiveKey="1"
        className="loan-detail-tabs"
      >
        <TabPane tab="Client Detail" key="1">
          <Image
            width={250}
            height={250}
            src={clientData?.image}
            fallback={fallbackImg}
          />
          <Descriptions
            title={`${clientData?.title} ${clientData?.surname} ${clientData?.firstname}`}
            layout="vertical"
            className="mt-3"
          >
            {clientData?.union && (
              <Descriptions.Item label="Union">
                {clientData?.union?.name}
              </Descriptions.Item>
            )}

            <Descriptions.Item label="Credit Officer">
              {clientData?.co_fullname}
            </Descriptions.Item>

            <Descriptions.Item label="House Address">
              {clientData?.house_address}
            </Descriptions.Item>

            <Descriptions.Item label="Office Address">
              {clientData?.office_address}
            </Descriptions.Item>

            <Descriptions.Item label="Phone Number 1">
              {clientData?.phone_number1}
            </Descriptions.Item>

            <Descriptions.Item label="Phone Number 2">
              {clientData?.phone_number2}
            </Descriptions.Item>

            <Descriptions.Item label="Marital Status">
              {clientData?.marital_status}
            </Descriptions.Item>

            <Descriptions.Item label="Number of children">
              {clientData?.number_of_children}
            </Descriptions.Item>

            <Descriptions.Item label="Registration fee">
              {clientData?.reg_fee}
            </Descriptions.Item>

            <Descriptions.Item label="NIN">{clientData?.nin}</Descriptions.Item>

            <Descriptions.Item label="Branch Name">
              {clientData?.branch_name}
            </Descriptions.Item>

            <Descriptions.Item label="Area Name">
              {clientData?.area_name}
            </Descriptions.Item>

            <Descriptions.Item label="Zone Name">
              {clientData?.zone_name}
            </Descriptions.Item>

            <Descriptions.Item label="State Name">
              {clientData?.state_name}
            </Descriptions.Item>
          </Descriptions>

          <hr />

          <h6>Union</h6>

          {clientData?.union ? (
            <div></div>
          ) : (
            <div className="d-flex flex-column">
              <div className="mb-3">Client does not belong to any Union</div>
              <Select
                allowClear
                className="default-ant-select"
                placeholder="Select Union"
                value={unionInput}
                onChange={(val) => setUnionInput(val)}
              >
                {unionOptions?.map((val) => (
                  <Option value={val?.id} key={val?.id}>
                    {val?.name}
                  </Option>
                ))}
              </Select>

              <Button
                disabled={loading || assigningUnion}
                onClick={handleAssignUnion}
                variant="primary"
                className="mt-3 btn-sm"
                type="submit"
              >
                Submit
              </Button>
            </div>
          )}
        </TabPane>

        <TabPane tab="Loans" key="2">
          <h5 className="mb-4">List of Loans</h5>

          <ModifiedAntTable
            rowKey="id"
            scroll={{ x: "max-content" }}
            columns={loanColumns}
            dataSource={clientLoans}
            bordered
            loading={loading}
            pagination={{
              defaultCurrent: loanPage,
              current: setLoanPage,
              defaultPageSize: 50,
              hideOnSinglePage: true,
              onChange: (current) => setWithdrawPage(current),
            }}
          />
        </TabPane>
        <TabPane tab="Withdrawal Form" key="3">
          <WithdrawalForm
            clientData={clientData}
            userId={user?.id}
            handleTriggerRefresh={handleTriggerRefresh}
          />
        </TabPane>
        <TabPane tab="Withdrawal List" key="4">
          <h5 className="mb-4">List of Withdrawals</h5>

          <ModifiedAntTable
            rowKey="id"
            scroll={{ x: "max-content" }}
            columns={withdrawalColumn}
            dataSource={withdrawalData}
            bordered
            loading={loading}
            pagination={{
              defaultCurrent: withdrawPage,
              current: withdrawPage,
              defaultPageSize: 50,
              hideOnSinglePage: true,
              onChange: (current) => setWithdrawPage(current),
            }}
          />
        </TabPane>

        <TabPane tab="Change Client Image">
          {clientData?.image && (
            <Image
              width={250}
              height={250}
              src={clientData?.image}
              fallback={fallbackImg}
            />
          )}

          <ImgCrop>
            <Upload
              name="image"
              listType="picture-card"
              className="avatar-uploader p-2"
              maxCount={1}
              disabled={!isProd}
              onChange={(file) => handleImage(file)}
            >
              <div className="p-1">
                <i className="fa fa-upload" aria-hidden="true"></i>
                Click to Upload
              </div>
            </Upload>
          </ImgCrop>

          {!isProd && (
            <small>Image upload not supported on this environment</small>
          )}
        </TabPane>
      </Tabs>
    </Container>
  );
};

export { ClientProfile };
